/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/layouts/fade-region',['require','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var FadeRegion = Marionette.Region.extend({

  //////////////
  // METHODS //{
  //////////////

    attachHtml: function(view)
    {
      this.$el.hide();
      this.$el.html(view.el);
      this.$el.fadeIn(500);
    }

  /*****************************************************************************************************************///}

  });

  return FadeRegion;

});

